import React from "react";

type Variant = "primary" | "success" | "info" | "warning" | "danger" | "secondary";
type Size = "sm" | "md" | "lg";

type SectionHeaderProps = {
  title: React.ReactNode;
  icon?: string;               // Remix icon class, e.g. "ri-user-3-line"
  variant?: Variant;           // uses Bootstrap text-* color on the icon
  color?: string;              // custom hex/rgb for the icon (overrides variant)
  size?: Size;                 // icon + title sizing
  divider?: boolean;           // optional subtle underline
  className?: string;
};

function cx(...a: Array<string | false | null | undefined>) {
  return a.filter(Boolean).join(" ");
}

export default function SectionHeader({
  title,
  icon = "ri-user-3-line",
  variant = "primary",
  color,           // if provided, overrides variant
  size = "md",
  divider = false,
  className,
}: SectionHeaderProps) {
  const iconSize = size === "sm" ? 18 : size === "lg" ? 22 : 20;
  const titleSize = size === "sm" ? "fs-16" : size === "lg" ? "fs-5" : "fs-16";

  return (
    <div className={cx(
      "d-flex align-items-center gap-2",
      className
    )}>
      {/* Color the icon only */}
      <i
        className={cx(icon, !color && `text-${variant}`)}
        style={{ fontSize: iconSize, ...(color ? { color } : {}) }}
        aria-hidden="true"
      />
      <span className={cx("fw-medium", titleSize)}>{title}</span>
    </div>
  );
}
